import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import {
    Card, CardContent, CardHeader, IconButton,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@mui/material';
import { Edit } from '@mui/icons-material';
import { CarModel, StockStatus } from 'models/StockModel';
import { CompanyType } from 'models/CompanyModel';
import useCarModals from 'modules/cars/hooks/useCarModals';
import auth from 'recoil/atoms/auth';


type InnerCargoCardProps = {
    car: CarModel,
}

const InnerCargoCard = ({car}: InnerCargoCardProps) => {
    const my = useRecoilValue(auth);
    const {t} = useTranslation('cars');
    const {openInnerCargoModal} = useCarModals();

    const notes = car.albums
        .filter(a => (a.name === 'yard_note' || a.name === 'yard_cargo') && a.note)
        .map(a => `${a.note}\n`);

    return (
        <Card sx={{mb: 2}}>
            <CardHeader
                title={t('inner_cargo')}
                action={my.permissions.has('cars update cargo') && (car.status === StockStatus.Pending || my.type === CompanyType.Master) &&
                    <IconButton
                        onClick={() => openInnerCargoModal(car)}
                    >
                        <Edit/>
                    </IconButton>
                }
            />

            {notes.length > 0 && (
                <CardContent sx={{whiteSpace: 'pre-wrap'}}>
                    {notes}
                </CardContent>
            )}

            {car.innerCargo.length > 0 && (
                <TableContainer>
                    <Table aria-label="Inner cargo table">
                        <TableHead>
                            <TableRow>
                                <TableCell>{t('name')}</TableCell>
                                <TableCell>{t('quantity')}</TableCell>
                                <TableCell>{t('weight')}</TableCell>
                                <TableCell>{t('price')}</TableCell>
                                <TableCell>{t('description')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {car.innerCargo.map(a => (
                                <TableRow
                                    key={a.id}
                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                >
                                    <TableCell>{a.name}</TableCell>
                                    <TableCell>{a.quantity}</TableCell>
                                    <TableCell>{a.weight}</TableCell>
                                    <TableCell>{a.price}</TableCell>
                                    <TableCell>{a.description}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Card>
    );
};

export default InnerCargoCard;
